import React from "react";
import { Button } from "@mui/material";
import { FileUploadOutlined } from "@mui/icons-material";
import BTNLoader from "./BTNLoader";

/**
 * Shared Export action button used across list pages.
 * Matches the admin dashboard export control (outlined, rounded, icon + label).
 */
const AppExportButton = ({
  onClick,
  disabled = false,
  isLoading = false,
  label = "Export",
  sx = {},
  ...props
}) => {
  return (
    <Button
      variant="outlined"
      onClick={onClick}
      disabled={disabled || isLoading}
      startIcon={isLoading ? <BTNLoader isLoading /> : <FileUploadOutlined />}
      sx={{
        textTransform: "none",
        fontWeight: 500,
        fontSize: 14,
        lineHeight: 1.2,
        color: "#1E293B",
        backgroundColor: "#FFFFFF",
        borderColor: "#D1D5DB",
        borderRadius: "3px",
        px: 3,
        py: 1,
        minHeight: 40,
        minWidth: 120,
        whiteSpace: "nowrap",
        boxShadow: "none",
        "& .MuiButton-startIcon": {
          marginRight: "8px",
          color: "#1E293B",
        },
        "&:hover": {
          backgroundColor: "#F8FAFC",
          borderColor: "#CBD5E1",
          boxShadow: "none",
        },
        "&.Mui-disabled": {
          backgroundColor: "#FFFFFF",
          borderColor: "#E5E7EB",
          color: "#94A3B8",
        },
        ...sx,
      }}
      {...props}
    >
      {label}
    </Button>
  );
};

export default AppExportButton;
